import { useAppDispatch, useAppSelector } from "@/state/redux/hooks";
import { useSidebar } from "../sidebar";
import { useEffect } from "react";
import {
  requestOpenCollectionsSidebar,
  selectCollectionsSidebarRequested,
} from "@/state/redux/slices/ui";

/**
 * Opens the collections sidebar when something outside it asks.
 *
 * Must live inside that sidebar's own SidebarProvider — `useSidebar()` reads
 * the nearest context, and the two sidebars have one each.
 */
export default function CollectionsSidebarController() {
  const dispatch = useAppDispatch();
  const { setOpenMobile } = useSidebar();
  const requested = useAppSelector(selectCollectionsSidebarRequested);

  useEffect(() => {
    if (requested) {
      setOpenMobile(true);
      // One-shot: clear the request so the next one is seen as a new edge.
      dispatch(requestOpenCollectionsSidebar(false));
    }
  }, [requested, setOpenMobile, dispatch]);

  return null;
}
